import angular from 'angular';
import pipelineLabelColorPicker from './pipelineLabelColorPicker';
import './style.scss';

export default angular
  .module('components.pipelineLabelColorPicker', [])
  .component('pipelineLabelColorPicker', pipelineLabelColorPicker).name;
